import { ActionType, createAction } from "typesafe-actions";

import {
  ListContextEntityType,
  ListQuery,
  MapPanelQuery,
  MapQuery,
  PlannerContextView,
  PlannerQuery,
  TerritoryPinsBounds,
  TerritoryQuery,
  ViewContextEntry,
} from "./ViewContextState";

export const registerViewContext = createAction("@chat/viewContext/register")<ViewContextEntry>();

export const unregisterViewContext = createAction("@chat/viewContext/unregister")<
  ViewContextEntry["instanceId"]
>();

// Carries the anchor the bar showed, so a click racing a navigation cannot detach the wrong one.
export const detachViewContext = createAction("@chat/viewContext/detach")<
  ViewContextEntry["anchorKey"]
>();

// Carries the anchor the bar showed, for the same race as detach.
export const pinViewContext =
  createAction("@chat/viewContext/pin")<ViewContextEntry["anchorKey"]>();

export const unpinViewContext = createAction("@chat/viewContext/unpin")();

// Back to whatever the current page infers: the one way out of a pin or a detach.
export const resetViewContext = createAction("@chat/viewContext/reset")();

// Dispatched by a list's fetch saga after a fetch succeeds, with the query it sent.
export const setListQuery = createAction("@chat/viewContext/setListQuery")<
  ListQuery & { entityType: ListContextEntityType }
>();

// Dispatched when the map has no successful fetch to describe, so the chat describes the screen alone.
export const clearMapQuery = createAction("@chat/viewContext/clearMapQuery")();

// Dispatched by the map's fetch saga after a fetch succeeds, with the query it sent.
export const setMapQuery = createAction("@chat/viewContext/setMapQuery")<MapQuery>();

// Dispatched by the map's records saga after a multi-pin fetch succeeds, with the query it sent.
export const setMapPanelQuery = createAction("@chat/viewContext/setMapPanelQuery")<MapPanelQuery>();

// Dispatched when a planner view skips its fetch, so the chat describes the screen alone.
export const clearPlannerQuery = createAction(
  "@chat/viewContext/clearPlannerQuery"
)<PlannerContextView>();

// Dispatched by the calendar's and scheduler's fetch sagas after a fetch succeeds.
export const setPlannerQuery = createAction("@chat/viewContext/setPlannerQuery")<
  PlannerQuery & { view: PlannerContextView }
>();

// Dispatched by the territory's records saga after a fetch succeeds, with what it listed.
export const setTerritoryQuery = createAction(
  "@chat/viewContext/setTerritoryQuery"
)<TerritoryQuery>();

// Dispatched by the territory's pins saga after a fetch succeeds, with the bounds it sent.
export const setTerritoryPinsBounds = createAction(
  "@chat/viewContext/setTerritoryPinsBounds"
)<TerritoryPinsBounds>();

export type ChatViewContextActions = ActionType<
  | typeof clearMapQuery
  | typeof clearPlannerQuery
  | typeof detachViewContext
  | typeof pinViewContext
  | typeof registerViewContext
  | typeof resetViewContext
  | typeof setListQuery
  | typeof setMapPanelQuery
  | typeof setMapQuery
  | typeof setPlannerQuery
  | typeof setTerritoryPinsBounds
  | typeof setTerritoryQuery
  | typeof unpinViewContext
  | typeof unregisterViewContext
>;
